<template>
  <div class="body" ref="body" part="mw-body">
    <div v-if="loading">
      <v-skeleton-loader
          type="card-avatar"
          height="105"
          class="mb-4"
      ></v-skeleton-loader>
    </div>
    <div v-else class="tile-box" part="mw-tile-box" :class="backgroundClass">

      <div v-if="hintHeader || hintContent || hintFooter" class="tile-header tile-flex">
        <div class="col-11 p-0">{{ title || titleFrom }}</div>

        <div class="col-1 p-0 text-right">
          <mlm-popover trigger="click" :options="{placement: 'auto'}" ref="mlmpc_000">

            <span slot="header" v-if="hintHeader" class="pop-head">
              {{ hintHeader }}
            </span>

            <div slot="body" class="popup-body" v-if="hintContent" v-bind:style="{minWidth: hintContentWidth ? hintContentWidth : 'auto'}">
              {{ hintContent }}
            </div>

            <div slot="footer" v-if="hintFooter">
              {{ hintFooter }}
            </div>

            <button slot="reference" class="canEdit control-label" v-bind:id="'id_b_000'" style="outline: none;">
              <font-awesome-icon class="hint-icon" icon="info-circle"/>
            </button>
          </mlm-popover>
        </div>
      </div>
      <div v-else-if="title" class="tile-header" part="mw-tile-header">
        {{ title }}
      </div>
      <div v-else class="tile-header" part="mw-tile-header">
        {{ titleFrom }}
      </div>
      <div class="tile-content-wrapper" part="mw-tile-content-wrapper">
        <i class="glyph-icon" :class="iconClass"></i>
        <div class="tile-content" part="mw-tile-content" style="min-height: 50px;">
          <template v-if="propertyType === 'date'">
            {{value}}
          </template>
          <template v-else>
            <template v-if="totalRound">
              {{ wMM((Math.round(value*100)).toString()).slice(0,-3)}}
            </template>
            <template v-else>
              <template v-if="typeof value === 'number'">
                {{ wMM((Math.round(value*100)).toString()).slice(0,-2)}}<small class="d-inline-block">{{wMM((Math.round(value*100)).toString()).slice(-2)}}</small>
              </template>
              <template v-else>
                {{value}}
              </template>
              <span class="d-inline-block ml-1">{{postfix}}</span>
            </template>
          </template>

        </div>
      </div>
    </div>
    <div v-html="innerHtmlCode"></div>
  </div>

</template>
<script>
import {VSkeletonLoader} from 'vuetify/lib'
import mlmPopover from '../../nested_components/mlm_popover/Popover'
import Layer0 from '../../extend_classes/Layer0'

import {library} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {faPlus, faInfoCircle} from '@fortawesome/free-solid-svg-icons' 
library.add(faPlus, faInfoCircle);

export default {
  name: 'metric-widget',
  components: {VSkeletonLoader, mlmPopover, FontAwesomeIcon},
  extends: Layer0,
  props: {
    propertyAlias: {
      type: String,
      default: ''
    },
    activePeriod: {
      type: Boolean,
      default: false
    },
    accountId: {
      required: false,
      type: Number
    },
    backgroundClass: {
      type: String,
      default: 'content-box'
    },
    treeId: {
      type: String,
      default: ''
    },
    hintHeader: {
      type: String,
      default: ''
    },
    hintContent: {
      type: String,
      default: ''
    },
    hintFooter: {
      type: String,
      default: ''
    },
    hintContentWidth: {
      type: String,
      default: ''
    },
    postfix: {
      type: String,
      default: ''
    },
    propertyType: {
      type: String,
      default: ''
    },
    totalRound: {
      type: Boolean,
      default: false,
      required: false
    },
    iconClass: {
      type: String,
      default: ''
    },
    offset: {
      default: '0',
      required: false,
      type: String
    },
    numberPeriodsBack: {
      required: false,
      type: String
    },
    innerHtmlCode: {
      required: false,
      type: String
    },
    title: {
      required: false,
      type: String
    },
  },
  data() {
    return {
      wMM: a => a,
      value: null,
      titleFrom: ''
    }
  },
  methods: {
    timeConverter(UNIX_timestamp){
      let a = new Date(UNIX_timestamp * 1000);
      // let months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      let year = a.getFullYear();
      let month = a.getMonth();
      let date = a.getDate();
      // let hour = a.getHours();
      // let min = a.getMinutes();
      // let sec = a.getSeconds();
      let time = date + '.' + month + '.' + year;
      return time;
    },
    getAp() {
      this.wMM = window.MLMSoftUICore.wearMaskMoney;
    },
    async getInfo() {
      this.aid = this.accountId || await this.store.dispatch('getAccountId');

      console.log('-------------!!@!@!@!!!@------------------')

      let propsQuery = `properties[]=${this.propertyAlias}&`


      if (this.numberPeriodsBack) {
        propsQuery += `numberPeriodsBack=${this.numberPeriodsBack}&`
      }

      if (this.treeId !== '') {
        propsQuery += `treeId=${this.treeId}&`
      }

      if (this.offset) {
        propsQuery += `offset=${this.offset}&`
      }

      await this.store.dispatch('requestApi3', {
        path: `account/${this.aid}/position?${propsQuery}`,
        method: 'get'
      }).then(response => {
        this.value = response?.data?.payload[0]?.properties[0]?.value?.presentable;

        if (response?.data?.payload[0]?.properties[0]?.fieldType?.alias == 'date' && !this.value) {
          this.value = ''
        } else if(!this.value) {
          this.value = '0'
        }
        console.log('response?.data?.map?.properties[0]?.title', response?.data?.map?.properties[0]?.title)

        this.titleFrom = response?.data?.payload[0]?.properties[0]?.title
      }).catch((e) => {
        console.log(e)
      }).finally(
          () => {
            this.loading = false;
          })
    }
  }
}
</script>
<style scoped>
@import '~vuetify/dist/vuetify.min.css';
@import '~bootstrap/dist/css/bootstrap.min.css';
@import "./../../styles/monarch/themes/admin/color-schemes/default.css";
@import "./../../styles/monarch/helpers/colors.css";
@import "./../../styles/monarch/helpers/boilerplate.css";
@import "./../../styles/monarch/helpers/border-radius.css";
@import "./../../styles/monarch/themes/components/border-radius.css";
@import "./../../styles/monarch/elements/tile-box.css";
@import "./../../styles/monarch/elements/content-box.css";
@import "./../../styles/monarch/themes/components/default.css";
@import "./../../styles/monarch/helpers/utils.css";
@import "./../../styles/monarch/helpers/typography.css";
@import "./../../styles/monarch/icons/fontawesome/fontawesome.css";
small{
  font-size:80% !important;
  display: inline !important;
  text-align: right !important;
  opacity: 1 !important;
  -moz-opacity: 1 !important;
  filter: alpha(opacity: 100) !important;
}
span {
  font-size: 90%;
}
.tile-content {
  font-size: 25px;
}
.tile-header{
  min-height: 30px !important;
}

.tile-flex {
  display: flex
}

.hint-icon {
  width: 12px;
  height: 12px;
  top: -2px;
  position: relative;

}
</style>
